<template>
  <div class="edit-user-wrap">
    <div class="eu-header">
      <div class="eu-info-row">
        <div class="eu-info-item">
          <span class="eu-label">User ID</span>
          <span class="eu-badge eu-badge--blue" translate="no">{{ userId }}</span>
        </div>
        <div class="eu-info-item" v-if="proxy_username">
          <span class="eu-label">{{ $t('msg.User_agent') }}</span>
          <span class="eu-badge eu-badge--gray" translate="no">{{ proxy_username }}</span>
        </div>
      </div>
    </div>

    <el-form :model="userInfo" :rules="userRules" ref="user" label-width="90px" class="eu-form">
      <el-form-item :label="$t('msg.Password2')" prop="password">
        <el-input v-model="userInfo.password" @focus="clearDefault" @blur="addDefaule" autocomplete="off" style="width:260px;"></el-input>
      </el-form-item>
      <el-form-item :label="$t('msg.Name2')">
        <el-input v-model="userInfo.realname" autocomplete="off" style="width:260px;"></el-input>
      </el-form-item>
      <el-form-item :label="$t('msg.Tel')">
        <el-input v-model="userInfo.pnum" autocomplete="off" style="width:260px;"></el-input>
      </el-form-item>
      <el-form-item :label="$t('msg.Description1')">
        <el-input v-model="userInfo.description" type="textarea" :rows="3" resize="vertical" style="width:260px;"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="updateUser">{{ $t('msg.OK1') }}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import {GetUserInfo, UpdateUserInfo} from "../api";
var LxStr = function(str){
  if(str){
    var arr = str.split('');
    var flag = true;
    for (var i = 1; i < arr.length-1; i++) {
      var firstIndex = arr[i-1].charCodeAt();
      var secondIndex = arr[i].charCodeAt();
      var thirdIndex = arr[i+1].charCodeAt();
      // thirdIndex - secondIndex == 1;
      // secondIndex - firstIndex==1;
      if((thirdIndex - secondIndex == 1)&&(secondIndex - firstIndex==1)){
        flag =  false;
      }
    }
    return flag;
  }
}
export default {
  name: "EditUser",
  data() {
    return {
      userId: 0,
      proxy_username: '',
      userInfo: {realname: '', pnum: '', description: '', password: "******"},
      userRules: {
        password: [
          {required: true, message: this.$t('msg.Please_enter_your_password'), trigger: 'blur'},
          {
            validator: (rule, value, callback) => {
              if (value === "******") {
                  callback();
                }
              else if (value.length < 6 || value.length > 15) {
                callback(new Error(this.$t('msg.Password_format_hint')));
              } else if (value.search(/\d/) == -1) {
                callback(new Error(this.$t('msg.Password_format_hint')));
              } else if (value.search(/[a-zA-Z]/) == -1) {
                callback(new Error(this.$t('msg.Password_format_hint')));
              } else if (value.search(/[^a-zA-Z0-9\!\_-]/) != -1) {
                callback(new Error(this.$t('msg.Password_format_hint')));
              }
              else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],
      },
    }
  },
  methods: {
    get_user_data() {
      GetUserInfo({"user_id": this.userId}).then((data) => {
        if (data.data.errcode === 0 && data.data.params.status === 0) {
          this.userInfo.realname = data.data.params.user.realname
          this.userInfo.pnum = data.data.params.user.pnum
          this.userInfo.description = data.data.params.user.description
          this.proxy_username = data.data.params.user.proxy_username
        } else {
          msg = data.data.params.msg
          if (!data.data.params.msg) {
            var msg = this.$t('msg.Failed_to_obtain_data')
          }
          this.$message({
            message: msg,
            type: 'error',
            offset: 80
          });
        }
      })
    },
    updateUser() {
      var val = true
      var from = 'user'
      this.$refs[from].validate(valid => {
        if (!valid) {
          // 表单验证失败，显示错误消息...
          val = false
        }
      })
      //添加代理
      if (val) {
        var params = {}
        if (this.userInfo.password !== "******") {
          params["password"] = this.userInfo.password
        }
        params["user_id"] = this.userId
        params["realname"] = this.userInfo.realname
        params["pnum"] = this.userInfo.pnum
        if (this.userInfo.description){
          params["description"] = this.userInfo.description
        }
        UpdateUserInfo(params).then((data) => {
          if (data.data.errcode === 0 && data.data.params.status === 0) {
            this.$message({
              message: this.$t('msg.Successful_operation'),
              type: 'success',
              offset: 80
            });

          } else {
            msg = data.data.params.msg
            if (!data.data.params.msg) {
              var msg = this.$t('msg.Failed_to_obtain_data')
            }
            this.$message({
              message: msg,
              type: 'error',
              offset: 80
            });
          }
        })
      }

    },
    clearDefault(){
      if(this.userInfo.password === "******"){
        this.userInfo.password = ""
      }
    },
    addDefaule(){
      if(this.userInfo.password === ""){
        this.userInfo.password = "******"
      }
    }
  },
  mounted() {
    this.userId = this.$route.query.user_id
    this.get_user_data()
  }
}
</script>

<style lang="less" scoped>
.edit-user-wrap {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .08);
  padding: 24px;
  max-width: 480px;
}

.eu-header {
  padding-bottom: 16px;
  margin-bottom: 20px;
  border-bottom: 1px solid #ebeef5;
}

.eu-info-row {
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
}

.eu-info-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.eu-label {
  color: #909399;
  font-size: 13px;
}

.eu-badge {
  border-radius: 4px;
  padding: 3px 12px;
  font-size: 14px;
  font-weight: 700;

  &--blue {
    background: #ecf5ff;
    color: #409eff;
    border: 1px solid #d9ecff;
  }

  &--gray {
    background: #f4f4f5;
    color: #606266;
    border: 1px solid #dcdfe6;
  }
}

.eu-form {
  .el-form-item {
    margin-bottom: 16px;
  }
  .el-form-item:last-child {
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/EditUser.vue